// test1196
(1196 && 0);
